module.exports = __webpack_public_path__ + "static/media/svg-3.f3c727cc.svg";